<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是军校生？</h6>
            <div class="main_box">
                <p>军校生，亦称为军校学员。不论是在解放军军事院校还是武警军事院校中学习的学员，只要是在部队院校中就读的学生，皆称为军校学员。军校生是指根据军队建设需要，由军队院校从参加国家统一招生考试录取或保送入学且毕业后由军队统一分配的学生，也是我们常说军校学员。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">报考条件有哪些？<span>*以下为湖南省报考条件，其他省份请查阅考试院或院校公布的消息。</span></h6>
            <div class="main_box">
                <p>(1)年龄：考生年龄不低于17周岁、不超过20周岁(截至报考当年8月31日 ) 。</p>
                <p>(2)身高：男性身高162cm以上；女性身高160cm以上。</p>
                <p>(3)体重： 男性体重不超过标准体重（标准体重kg=身高cm-110）的30%，不低于标准体重的15%，其中音乐学专业体重不超过标准体重的35%；女性体重不超过标准体重的20%、不低于标准体重的15%，其中，音乐学专业体重不超过标准体重的35%。</p>
                <p>(4)视力：裸眼视力不低于4.5，任何一眼裸眼视力低于4.9，需进行矫正视力检查，任何眼矫正视力低于4.9或矫正度数超过600度，不合格。无色弱、色盲等眼疾。</p>
                <p>(5)无口吃（结巴）。</p>
                <p>(6)预计高考分数不低于本省（自治区、直辖市）本科二批、本科B批、本科批次、第二段控制线。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">军校类别</h6>
            <div class="main_box">
                <p>我国的军校分为全军院校和军兵种院校两大类。</p>
                <p>全军院校是指由四总部(总参谋部、总政治部、总后勤部、总装备部)直接管理的院校。对考生来说，选择这种院校，在毕业时选择面比较宽，学员将面向全军，包括海军、空军和第二炮兵或其他陆军在内进行分配。全军院校下面又分综合院校和专业院校两类。综合院校为国防现代化培养高级科学和工程技术人才与指挥人才，因此，其专业设置口径相对于专业院校来说较宽，专业数量相对较多，对考生来说选择的空间相对较大。</p>
                <p>军兵种院校，主要指各军兵种所属的各类院校，其主要特点是学员一般只在本军兵种范围内进行毕业分配，而不是面向全军。比如，海军院校的毕业学员，一般是到沿海的海军部队工作;空军院校的毕业学员一般到空军部队工作;第二炮兵或陆军其他兵种院校的毕业学员一般也只在本兵种范围内工作。</p>
            </div>
        </div>
        <div class="main liucheng">
            <h6 class="main_title">报考流程（以简章为主）</h6>
            <div class="main_box liucheng">
                <ul>
                    <li>报名</li>
                    <li>体格检查选对象</li>
                    <li>录取</li>
                    <li>复查和复试</li>
                    <li>面试、政治思想考核</li>
                    <li>文化科目考试</li>
                    <li>报道</li>
                    <li>办理入伍手续</li>
                </ul>
            </div>
        </div>
        <div class="universities main">
            <h6 class="main_title">军事院校<span>军校招生-生涯规划教育服务平台</span></h6>
            <table>
                <tr v-for="(item,index) in universities" :key="index">
                    <td>{{item.order}}</td>
                    <td><p>{{item.school_name}}</p></td>
                    <td><p>{{item.address}}</p></td>
                    <td><p>{{item.detail}}</p></td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [
                {"order":"1","school_name":"中国人民解放军国防大学","address":"北京","detail":"是中国最高军事学府，是中国军队唯一的一所高级合同指挥院校，直属中国共产党中央军事委员会领导。只有现役军官方可报考!"},
                {"order":"2","school_name":"装备指挥技术学院","address":"北京","detail":"学院隶属总装备部，是一所以军官培训和研究生教育为主体的中级任职教育院校。主要任务是为全军培养装备指挥管理人才，为国防科研、军事航天系统培养高级工程技术人才。"},
                {"order":"3","school_name":"解放军艺术学院","address":"北京","detail":"是中国人民解放军唯一的一所多学科、综合性高等艺术院校，担负着为全军培养文学艺术人才、文化管理干部和开展军事文艺研究等任务，被誉为“军队作家、艺术家的摇篮”。"},
                {"order":"4","school_name":"防化工程指挥学院","address":"北京","detail":"是全国重点高等学校，位于北京市西北郊，创建于1950年。学院担负着为全军培养中、初级防化指挥军官和中、高级防化工程技术军官的任务，是一所军事指挥和工程技术合一的综合性院校，也是全军唯一一所防化院校，军工六校之一。"},
                {"order":"5","school_name":"装甲兵工程学院","address":"北京","detail":"前身是哈军工装甲兵工程系。隶属于中国人民解放军陆军，是全国重点工科院校、军队“2110”工程重点建设院校、全军16所学历教育院校之一，是中国人民解放军装甲兵的最高学府，素有“陆战之王的摇篮”美称。"},
                {"order":"6","school_name":"陆军航空兵学院","address":"北京","detail":"隶属于中国人民解放军陆军部。主要任务是培养陆军航空兵中级政治指挥人才，陆、空军直升机飞行员和陆军航空工程机务干部。是一所军事与政治、指挥与技术、空勤与地勤、军官与士兵同校训练的多学科、多层次的综合型院校。"},
                {"order":"7","school_name":"隶属于中国人民解放军陆军部。主要任务是培养陆军航空兵中级政治指挥人才，陆、空军直升机飞行员和陆军航空工程机务干部。是一所军事与政治、指挥与技术、空勤与地勤、军官与士兵同校训练的多学科、多层次的综合型院校。","address":"湖南 长沙","detail":"是中华人民共和国中央军事委员会直属的综合性全国重点大学，是国家首批“211工程”、“985工程”、军队“2110工程”重点建设院校之一，入选“2011计划”、“卓越工程师教育培养计划”，由国防部、教育部双重领导，大军区级编制。是解放军未来科学家、技术专家和新型指挥军官的摇篮。"},
                {"order":"8","school_name":"解放军理工大学","address":"江苏 南京","detail":"是中国人民解放军总参谋部直属的一所新型的综合性全军重点院校，是全军重点建设的五所综合大学之一和对外开放院校，是军队“2110工程”重点建设院校之一，正军级编制。担负着培养高素质新型军事指挥和工程技术人才的重任。是国家和军队进行科学研究、技术创新和装备研制的重要基地。"},
                {"order":"9","school_name":"解放军镇江船艇学院","address":"江苏 镇江","detail":"为全军唯一一所为陆军、空军培养船艇军事人才的初级指挥学院。学院集指挥、管理、工程技术于一体，实施本科、大专、中专三个层次的教育，为陆、空军船艇部队培养了大批合格人才。"},
                {"order":"10","school_name":"中国人民解放军解放军国际关系学院","address":"江苏 南京","detail":"全国重点高等院校之一，隶属于中国人民解放军总参谋部，正军级，始建于1951年6月。是一所指挥与技术合一，以外语为基础，多专业、多层次、多规格的综合性军事外交学院，是军队培养国际关系、国防外事、军事外交、国际战略研究、外语师资、部队侦察、技术侦察、航天侦察、特种作战指挥等各类专业人才的重要基地，同时也为我军高等院校培养外语师资，是中国军事外交和外语专业人才的培训基地，被称为“中国军事外交官的摇篮”。是军队培养各类外语人才的重要基地。"},
                {"order":"11","school_name":"空军勤务学院","address":"江苏 徐州","detail":"主要承担空军作战后勤和装备保障研究生、本科生教育，以及生长干部和现职干部的任职培训，是全军培训规模较大的院校之一。"},
                {"order":"12","school_name":"南京炮兵学院","address":"江苏 南京","detail":"2011年由原解放军炮兵指挥学院与原解放军炮兵学院南京分院合并组建成立。"},
                {"order":"13","school_name":"2011年由原解放军炮兵指挥学院与原解放军炮兵学院南京分院合并组建成立。","address":"河南 郑州","detail":"是中国人民解放军总参谋部直属的全国理工科高等军事院校，是全军重点建设的五所综合大学之一，是军队“2110工程”重点建设院校之一，正军级编制。主要培养高、中级工程技术人才和指挥、管理干部的全国重点理工科高等军事院校。"},
                {"order":"14","school_name":"郑州防空兵学院","address":"河南 郑州","detail":"全军陆军唯一的防空兵指挥学院，隶属于总参谋部，担负着为陆、海军防空兵部队培养初级指挥军官和为外军培养军事留学生的任务。"},
                {"order":"15","school_name":"解放军外国语学院","address":"河南 洛阳","detail":"中国人民解放军外国语学院(PLA University of Foreign Language)是一所为国防和军队现代化建设服务，以外语为基础，多学科交叉、特色鲜明、高水平的综合性国防语言学院，也是全军外语人才培训基地、外国军事留学生汉语培训基地。担负着为全军培养外语人才、军队院校汉语师资和外军留学生汉语培训等任务。"},
                {"order":"16","school_name":"空军第一航空学院","address":"河南 信阳","detail":"隶属中国人民解放军空军，正师级。学院是一所培训航空工程技术人才的高等军事院校，主要担负着空军航空兵部队地勤各类技术军官和外军留学生的培训任务。"},
                {"order":"17","school_name":"中国人民解放军后勤工程学院","address":"重庆","detail":"是中国人民解放军总后勤部直属的全国重点高等院校，是军队“2110工程”重点建设院校之一，正军级编制。主要培养后勤专业技术人才。"},
                {"order":"18","school_name":"第三军医大学","address":"重庆","detail":"是一所有着光荣历史和鲜明军事特色的军医大学，是新中国成立后第一批全国重点大学，是军队“2110工程”重点建设院校之一，正军级编制，“卓越医生教育培养计划”试点高校。为全军培养军医人才，隶属总后勤部。"},
                {"order":"19","school_name":"重庆通信学院","address":"重庆","detail":"是全国唯一的军事高等通信院校，为全军培养初级通信指挥、通信技术军官的任务。隶属于总参谋部。"},
                {"order":"20","school_name":"解放军汽车管理学院","address":"安徽 蚌埠","detail":"是一所培养汽车排长和军交运输指挥管理干部的初级指挥院校，隶属于总后勤部。为全军汽车部队培养汽车运输指挥和管理军官。"},
                {"order":"21","school_name":"中国人民解放军陆军军官学院","address":"安徽 合肥","detail":"是一所承担步兵、炮兵、防空兵、装甲兵等陆军主战兵种初级指挥人才合训任务的学历教育院校，同时承担研究生教育、士官教育、外国军事留学生培训、现职干部轮训和优秀士兵保送入学学员培训等任务。"},
                {"order":"22","school_name":"蚌埠坦克学院","address":"安徽 蚌埠","detail":"是一所为全军装甲兵部队培养初级指挥军官的院校。为全军装甲兵部队培养初级指挥军官的军事院校。"},
                {"order":"23","school_name":"解放军电子工程学院","address":"安徽 合肥","detail":"是我军唯一一所面向全军专门培养新型电子信息类人才的高等军事院校，军队“2110工程”二期、三期重点建设院校。担负着为全军培养高素质新型信息作战和工程技术人才的任务。"},
                {"order":"24","school_name":"空军航空大学","address":"吉林 长春","detail":"副军级建制，是中国唯一一所以培养飞行人才为主体，航空飞行指挥与航空工程技术专业兼容的综合性军事高等学府。"},
                {"order":"25","school_name":"中国人民解放军装甲兵技术学院","address":"吉林 长春","detail":"是全军装甲机械化部队培养装甲装备技术保障人才的高等专业技术院校"},
                {"order":"26","school_name":"中国人民解放军军事交通学院","address":"天津 河东","detail":"是全军唯一培养军事交通运输和军用车辆装备领域高层次人才的学院，隶属总后勤部。"},
                {"order":"27","school_name":"中国人民解放军军事经济学院","address":"湖北 武汉","detail":"是培养军队后勤建设人才的高等军事学府，隶属于中国人民解放军总后勤部(现更名为中国共产党中央军事委员会后勤保障部)，是一所面向全军、全国招生的多学科、多层次，以培养军事经济管理人才为主要任务的学校。是军队创建较早的院校之一。"},
                {"order":"28","school_name":"海军工程大学","address":"湖北 武汉","detail":"是在中央军委、海军党委领导下的高等军事院校，是一所以工为主、工管结合、指技合一、文理兼容、具有鲜明海军特色的全国重点大学，是全军重点建设的五所综合大学之一和对外开放院校，是军队“2110工程”重点建设院校之一，正军级编制。"},
                {"order":"29","school_name":"通信指挥学院","address":"湖北 武汉","detail":"是培养通信指挥干部的军事指挥院校"},
                {"order":"30","school_name":"空军预警学院","address":"湖北 武汉","detail":"是全国唯一一所预警监视领域的专门院校，全军唯一一所预警监视和电子对抗均为主体学科专业的院校，全空军唯一一所指技兼容的中级军事任职教育院校。主要承担全军预警系统和空军地面电子对抗部队指挥技术军官及士官培养任务。"},
                {"order":"31","school_name":"中国人民解放军火箭军指挥学院","address":"湖北 武汉","detail":"为二炮部队培养指挥军官和高层次专门人才的中级指挥院校。是一所正军级中级指挥院校，是第二炮兵的指挥人才培训中心和军事理论研究中心，承担着为二炮部队培养战役指挥军官、中级指挥军官、军事学博士和硕士研究生、部分初级指挥军官以及地方高校毕业生等培训任务。"},
                {"order":"32","school_name":"解放军西安政治学院","address":"陕西 西安","detail":"是直属于解放军总政治部的一所中级任职高等教育院校，担负着全军政治军官任职培训和研究生的培养任务。"},
                {"order":"33","school_name":"空军工程大学","address":"陕西 西安","detail":"是一所融工、文、管、理、法、军等学科于一体的综合性全国重点大学，是全军重点建设的五所综合大学之一和对外开放院校，是军队“2110工程”重点建设院校之一，受空军和教育部双重领导，正军级编制。"},
                {"order":"34","school_name":"解放军空军西安飞行学院","address":"陕西 户县","detail":"2011年由空军第二飞行学院和中国人民解放军空军第五飞行学院合并而来，空军第二飞行学院与共和国同年诞生，有着光辉的战斗历程和优良的革命传统。"},
                {"order":"35","school_name":"第四军医大学","address":"陕西 西安","detail":"为军队培养高、中层次医学专门人才的综合性医科全国重点大学，是国家“211工程”、全军“2110工程”重点建设院校之一,“卓越医生教育培养计划”试点高校。隶属总后勤部。"},
                {"order":"36","school_name":"西安通信学院","address":"陕西 西安","detail":"是一所为全军培养初级通信指挥军官和工程技术军官的通信专业院校，隶属于总参谋部。"},
                {"order":"37","school_name":"中国人民解放军火箭军工程大学","address":"陕西 西安","detail":"是中国唯一一所培养战略导弹部队指挥技术人才的高等军事院校[1] ，是中国人民解放军重点院校，是军队“2110工程”重点建设院校，国务院学位委员会批准的首批博士、硕士、学士授予权单位之一，被誉为中国战略导弹部队军官的摇篮。"},
                {"order":"38","school_name":"中国人民解放军军械工程学院","address":"河北 石家庄","detail":"坐落在河北省会石家庄市中心，是中国人民解放军总装备部直属的全国重点高等院校，是军队“2110工程”重点建设院校之一，正军级编制。全军唯一培养高、中级军械装备技术保障和理论研究专门人才的院校。"},
                {"order":"39","school_name":"石家庄陆军指挥学院","address":"河北 石家庄","detail":"是一所军政指技参同校合训的综合性中级指挥院校，是军队“2110工程”重点建设的军种指挥院校，直属中国人民解放军总参谋部。"},
                {"order":"40","school_name":"白求恩军医学院","address":"河北 石家庄","detail":"是培养初、中级卫生专业技术干部的医务院校，隶属总后勤部。"},
                {"order":"41","school_name":"中国人民武装警察部队学院","address":"河北 廊坊","detail":"隶属于中华人民共和国公安部，为正军级单位，是中国唯一所为公安边防、消防、警卫部队培养指挥管理和专业技术警官的现役本科院校。是我国公安现役部队的最高学府。边防、消防、警卫专业为国内独有，还承担师以上干部的培训任务，是我国国际维和民事警察和警务联络官培训基地及学术交流中心。"},
                {"order":"42","school_name":"炮兵指挥学院","address":"河北 宣化","detail":"是一所中级指挥院校，是炮兵最高学府。主要肩负着培养我军炮兵(防空兵)团、旅军政指挥员，炮兵(防空兵)战术学和作战指挥硕士研究生，部分地高炮初级指挥军官的任务。"},
                {"order":"43","school_name":"中国人民解放军海军陆战学院","address":"广东 广州","detail":"是一所海军兵种战术中级指挥院校，隶属中国人民解放军海军，正师级。学院主要为海军培养水面舰艇、潜艇、航空兵、陆战队、岸防兵等众多兵种指挥员。"},
                {"order":"44","school_name":"海军潜艇学院","address":"山东 青岛","detail":"一所培养海军潜艇和防救部队初、中两级军事指挥、工程技术军官的重点军事院校。"},
                {"order":"45","school_name":"海军航空工程学院","address":"山东 烟台","detail":"是一所以培养海军指挥军官和航空工程技术军官和航空航天工程技术军官为主的高等军事学校，是海军指挥与工程技术人才培养的主要基地和航空航天领域科研中心之一。"},
                {"order":"46","school_name":"大连舰艇学院","address":"辽宁 大连","detail":"隶属于中国人民解放军海军，是经毛泽东主席批准成立的新中国第一所正规高等军事学府，是专门培养海军舰艇指挥军官、海军政治指挥军官和海洋测绘工程技术军官的高等军事学府，是全军重点建设院校，被誉为\"海军军官摇篮\"和“中国海军的黄埔军校”。"},
                {"order":"47","school_name":"沈阳炮兵学院","address":"辽宁 沈阳","detail":"是一座历史悠久的军事院校，前身是由八路军延安炮兵学校 。是一所炮兵初级指挥学院。"},
                {"order":"48","school_name":"桂林空军学院","address":"广西 桂林","detail":"一所为空军培养初级(含部分中级)指挥军官、参谋军官和工程技术人员，为全空军培训政治指导员的综合性军事院校。"},
                {"order":"49","school_name":"第二军医大学","address":"上海 杨浦","detail":"是中国共产党中央军事委员会训练管理部直属的一所为军队培养医学专门人才及卫生管理干部的全国重点医科大学，是国家“211工程”、军队“2110工程”和总后勤部“530工程”重点建设院校。"},
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/explore/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height:50px;
                    width: 150px;
                    height: 50px;
                    padding-right: 60px;
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat 150px center;
                    background-size: 20px 20px;
                    &:last-child {
                        padding-right: 0px;
                    }
                }
            }
        }
        .universities {
            table {
                border: 1px solid #eaeaea;
                font-size: 14px;
                text-align: center;
                tr {
                    &:nth-child(odd) {
                        background-color: #e6f8ff;
                    }
                    td {
                        line-height: 50px;
                        text-align: center;
                        color: #333;
                        border: 1px solid #eaeaea;
                        p {
                            line-height: 24px;
                        }
                        &:nth-child(1) {
                            width: 10%; 
                        }
                        &:nth-child(2) {
                            width: 25%; 
                            padding: 5px 10px;
                        }
                        &:nth-child(3) {
                            width: 10%; 
                        }
                        &:nth-child(4) {
                            text-align: left;
                            width: 55%; 
                            padding: 5px 10px;
                        }
                    }
                }
            }
        }
    }
</style>